module.exports = __webpack_public_path__ + "static/oldtast-3d7ab4c72f81aedf27f3d288591df6e0.jpg";